import { useMsal } from '@azure/msal-react';
import { BlockStack, Button, Card, Typography } from '@pv-frontend/ui-components-web';
import { Centered } from './centered';

/** Shown when a successfully-authenticated user is not in the admin group. */
export function AccessDenied() {
    const { instance } = useMsal();
    return (
        <Centered>
            <Card padding="700">
                <BlockStack gap="400" inlineAlign="center">
                    <BlockStack gap="100" inlineAlign="center">
                        <Typography variant="heading-lg" as="h1" tone="text-critical">
                            Access denied
                        </Typography>
                        <Typography tone="text-secondary">
                            Your account isn&rsquo;t a member of the PropertyVault admin group.
                        </Typography>
                    </BlockStack>
                    <Button variant="tertiary" size="slim" onPress={() => void instance.logoutRedirect()}>
                        Sign in with a different account
                    </Button>
                </BlockStack>
            </Card>
        </Centered>
    );
}
